<div class="flex flex-col h-full">
  @if (busySaving()) {
    <div class="w-full absolute">
      <mat-progress-bar
        class="mds-x-small"
        data-cy="classification-edit-loader"
        [mode]="'indeterminate'"
      ></mat-progress-bar>
    </div>
  }

  <div class="flex flex-row p-4 pr-6 border-b border-gray-1">
    <div class="h-8 flex flex-1 flex-wrap content-center font-semibold">
      {{ titleText() }}
    </div>
    <button
      id="options-panel-classification-edit-close"
      class="text-gray-8"
      modus-icon-button
      [modus-tooltip]="translations.close.tooltip.text"
      (click)="close()"
      [disabled]="busySaving()"
    >
      <md-icon>close</md-icon>
    </button>
  </div>

  @if (classificationScheme(); as classificationScheme) {
    <div class="flex-1 overflow-y-scroll p-4">
      <div class="text-small italic mb-4">
        {{ translations.notice.text }}
      </div>

      <!-- id -->
      <sd-label-value
        [label]="translations.input.number.text"
        value="{{ classificationScheme.id }}"
      ></sd-label-value>

      <!-- name -->
      <modus-form-field class="mb-2">
        <modus-label>{{ translations.input.name.text }}</modus-label>
        <input
          modus-input
          data-cy="classification-description-input"
          [formControl]="formGroup.controls.name"
          (blur)="trimInputValue(formGroup.controls.name)"
        />
      </modus-form-field>

      <!-- color -->
      <modus-label class="block text-small text-gray-8">
        {{ translations.input.color.text }}
      </modus-label>
      <div class="h-8 block mb-2 mt-[0.15rem]">
        <div class="w-10 h-5">
          <sd-color-picker
            [formControl]="formGroup.controls.rgba"
            [dialogPosition]="'bottom-right'"
          ></sd-color-picker>
        </div>
      </div>

      <!-- visibility -->
      <modus-label class="block text-small text-gray-8">
        {{ translations.input.visibility.text }}
      </modus-label>
      <modus-switch
        data-cy="classification-visibility-switch"
        [label]="visibilityLabel()"
        [formControl]="formGroup.controls.visible"
      ></modus-switch>

      <!-- error alert -->
      @if (showError()) {
        <div class="w-full mt-4">
          <modus-alert class="w-full" [message]="translations.error" type="error"></modus-alert>
        </div>
      }
    </div>
  }

  <div class="flex px-4 p-4 justify-end">
    <button
      id="options-panel-classification-edit-close"
      modus-button
      class="mr-4"
      color="secondary"
      (click)="close()"
      [disabled]="busySaving()"
    >
      {{ translations.cancel.text }}
    </button>

    <button
      id="options-panel-classification-edit-save"
      modus-flat-button
      color="secondary"
      (click)="save()"
      [disabled]="saveDisabled()"
    >
      {{ translations.save.text }}
    </button>
  </div>
</div>
